import styled from '@emotion/styled';

import { ExternalLink } from '../../../../../../../../../ExternalLink/ExternalLink';

export const Disclaimer = styled.div`
  font: var(--font-body-m-light);
  color: var(--color-secondary-70);
  border-top: solid 1px var(--color-secondary-85);
  margin: var(--spacing-16) 0 var(--spacing-8) 0;
  padding-top: var(--spacing-16);
`;

export const TermsAndConditions = styled(ExternalLink)`
  font: var(--font-body-m-light);
  color: var(--color-secondary-70);
`;
